'use strict';

var formValidation = require('../components/formValidation');
var isFormValid = false;

/**
 * To check validation on input and select form fields
 */
function checkValidation () {
    $(document).on('blur', "input:not(:checkbox), div.custom-select", function () {
        var $this = $(this);
        /* if ($(this).hasClass('custom-select')) {
            isFormValid = customSelectCheckValid($this) && formValidation.checkValidation($this.closest('.custom-select-wrapper').find('select'));
        } else {
            isFormValid = formValidation.checkValidation($this);
        } */
        isFormValid = formValidation.checkValidation($this);
    });

    $(document).on('blur', '#cardNumber', function() {
        if ($(this).parent('.card-number-wrapper').attr('data-type') === 'unknown') {
            $(this).addClass('is-invalid');
            $(this).siblings('.invalid-feedback').html($(this).attr('parse-error')).removeAttr('style');
            // disable the Save CC button here
            $('body').trigger('checkout:disableButton', '#btnSaveCC');
        }
     });
}

function isValidKeyCode(key) {
	return (key !== 13 && key !== 8 && key !== 0 && key !== 9 && (key < 48 || key > 57)) ? true : false;
}

function ctrlKey(ctrlKey,shiftKey,key) {
	return ((ctrlKey && key === 118 /* firefox */) || (ctrlKey && key === 86) /* opera */ || (shiftKey && key === 45)) ? true : false;
}

module.exports = {
    checkValidation,
    addValidation: function () {
        $("body").find('form').each(function () {
            formValidation.addInputValidations($(this));
        });
    },
    formatPostalCode: function() {
        $(document).on("focusout", ".formatpostal", function() {
            if ($(this).closest("form").find(".country").val() === "CA") {
                var element = $(this),
                postalCode	= element.val();	    		
                
                element.val(postalCode.toUpperCase().replace(/\W/g,'').replace(/(...)/,'$1 '));
            }
        });
    },
    numericOnly: function(){
		var obj = $(".numericonly");
		//if format phone don't put number only attribute as it will mess up the format SCHLRCO-6055
		if (!obj.hasClass("formatphone")) {
			$(".numericonly").attr({'type': 'number', 'pattern': '[0-9]*'});

		} else {
			obj.on('keypress keyup', function(e) {
				var key = e.keyCode || e.which;
				// allow Ctrl+A
				if((e.ctrlKey && key === 97 /* firefox */) || (e.ctrlKey && key === 65) /* opera */) { 
					return true; 
				}
				// allow Ctrl+X (cut)
				if((e.ctrlKey && key === 120 /* firefox */) || (e.ctrlKey && key === 88) /* opera */) { 
					return true; 
				}
				// allow Ctrl+C (copy)
				if((e.ctrlKey && key === 99 /* firefox */) || (e.ctrlKey && key === 67) /* opera */) { 
					return true; 
				}
				// allow Ctrl+Z (undo)
				if((e.ctrlKey && key === 122 /* firefox */) || (e.ctrlKey && key === 90) /* opera */) { 
					return true; 
				}
				// allow tab
				if(e.ctrlKey && key === 9 /* firefox */) { 
					return true; 
				}
				// allow or deny Ctrl+V (paste), Shift+Ins
				if(ctrlKey(e.ctrlKey,e.shiftKey,key)) { 
					return true; 
				}
			    if (isValidKeyCode(key)) {
			        return false;
			    }
		 	});
			obj.on('paste', function (e) {
				var strPasted;
			    setTimeout(function () {
			    	if ($(e.currentTarget).hasClass("formatphone")) {
			    		strPasted=$(e.currentTarget).val().replace(/-/g, "");
			    	} else {
			    		strPasted=$(e.currentTarget).val();
			    	}
			        if (isNaN(strPasted)) {
			        	$(e.currentTarget).val("");
			        }
			    },0);
			    
			});
		}
	},
    formatPhoneNumber: function() {
        $(document).on('input keyup blur mousedown', '.formatphone', function(e) {
            var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0,
                character = String.fromCharCode(e.which),
                $phoneval = $(this).val(),
                $replaceval = $phoneval.replace(/-/g,''),
                hipenlength = $phoneval.match(/-/g) ? $phoneval.match(/-/g).length : 0,
                leading_value = $replaceval.length,
                specialKeys = [8,9,17,46,36,35,37,39];
    
            if ($phoneval.length === 0 && character === '1') {
                $(this).val('');
                return false;
            }
            if (specialKeys.indexOf(key) === -1) {
                if (hipenlength < 2){
                    if ($replaceval.length > 3 && $replaceval.length < 5 && $phoneval.match(/-/g) == null) {
                        $(this).val($replaceval.substr(0,3)+'-'+$replaceval.substr(3,3));
                    } else if ($replaceval.length > 6 && $phoneval.match(/-/g) != null && $phoneval.match(/-/g).length === 1) {
                        $(this).val($replaceval.substr(0,3)+'-'+$replaceval.substr(3,3)+'-'+$replaceval.substr(6,4));
                    } else if ($replaceval.length > 10 || (hipenlength === 0 && $replaceval.length >= 10)) {
                        $(this).val($replaceval.substr(leading_value - 10,3)+'-'+$replaceval.substr(leading_value - 7,3)+'-'+$replaceval.substr(leading_value - 4,4));
                    }
                } else if ($replaceval.length === 10 && hipenlength < 2) {
                    $(this).val($replaceval.substr(0,3)+'-'+$replaceval.substr(3,3)+'-'+$replaceval.substr(6,4));
                } else if ($replaceval.length > 10 && hipenlength >= 2 && e.type === "blur") {
                    $(this).val($replaceval.substr(leading_value - 10,3)+'-'+$replaceval.substr(leading_value - 7,3)+'-'+$replaceval.substr(leading_value - 4,4));
                }
            }
        });
    },
    enableDisbaleButton : function(formID, buttonID) {
		var $button = buttonID !== undefined ? $(buttonID) : $(formID).find("button[type=submit]"),
		    keepDisable = false,
			elements = 'select:visible, input:visible';
		clearTimeout(formButtonValidationTimeout);
		
		var formButtonValidationTimeout = setTimeout(function() {
		    $.each($(formID).find(elements), function() {
		    	if ($(this).hasClass("is-invalid") || (($(this).val() === "" || $(this).val() ==="null") && ($(this).parent('.form-group').hasClass("required") || $(this).parents('.form-group').hasClass("required")))) {
		    		keepDisable = true;
		    		return;
		    	}
		    });

            if ((formID === '#createAccountModal' || formID === '#dwfrm_profile_changeschoolrole') && $('.account-grades-list:visible').length && !keepDisable) {
                if (!$('.account-grades-list input[type="checkbox"]:visible:checked').length) {
                    keepDisable = true;
                }
            }

			if (keepDisable) {
				$button.attr("disabled","disabled");
			} else {
				$button.removeAttr("disabled");
			}
    	},500);
	}
}
